module.exports = __webpack_public_path__ + "static/img/digital_business_creator.6f0c19e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/application/digital_business_creator.svg
// module id = +Xxz
// module chunks = 0